(() => {
  let l = (e, t) => {
      !e.querySelector(".featured-products__wrapper").swiper ||
      t.closest(".swiper-slide-visible")
        ? t.play()
        : t.pause();
    },
    i = (t) => {
      var e,
        r,
        s,
        i,
        o,
        a = t.querySelector(
          ".featured-products__slider:not(.swiper-initialized",
        );
      a &&
        ((e = a.parentElement.querySelector(".featured-products__navigation")),
        (o = a.querySelector(".featured-products__pagination")),
        (s = 5 == (r = Number(a.dataset.columns)) ? 4 : r),
        (i = 4 <= r ? s - 1 : s),
        (o = {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 8,
          mousewheel: { forceToAxis: !0 },
          watchSlidesProgress: !0,
          speed: 800,
          pagination: {
            el: o,
            type: "custom",
            renderCustom: function (e, t, r) {
              let s = "";
              for (let e = 1; e < r + 1; e++)
                s =
                  e == t
                    ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                    : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
              return s;
            },
          },
          breakpoints: {
            750: {
              slidesPerView: (o = 2 <= r ? 2 : r),
              slidesPerGroup: o,
              spaceBetween: 24,
            },
            990: {
              slidesPerView: (o = 3 == r ? i - 1 : 4 <= r ? 3 : i),
              slidesPerGroup: o,
              spaceBetween: 24,
            },
            1200: { slidesPerView: i, slidesPerGroup: i, spaceBetween: 24 },
            1360: { slidesPerView: s, slidesPerGroup: s, spaceBetween: 24 },
            1600: { slidesPerView: r, slidesPerGroup: r, spaceBetween: 24 },
          },
          on: {
            slideChange() {
              this.slides.forEach((e) => {
                e.querySelector(".featured-products__item-video video") &&
                  l(t, e.querySelector(".featured-products__item-video video"));
              });
            },
          },
        }),
        e &&
          (o.navigation = {
            nextEl: e.querySelector(".swiper-button-next"),
            prevEl: e.querySelector(".swiper-button-prev"),
          }),
        new Swiper(a, o));
    },
    o = (e) => {
      e = e.querySelector(".featured-products__slider");
      e &&
        (e.swiper && e.swiper.destroy(),
        e.querySelector(".swiper-wrapper").removeAttribute("style"));
    },
    t = (s) => {
      if (s) {
        let t = s.querySelector(".featured-products__slider"),
          r = new IntersectionObserver((e) => {
            e.forEach((e) => {
              e.isIntersecting ? l(s, e.target) : e.target.pause();
            });
          });
        s
          .querySelectorAll(".featured-products__item-video video")
          .forEach((e) => {
            r.observe(e);
          }),
          t &&
            new ResizeObserver((e) => {
              var [e] = e;
              ("true" != t.dataset.sliderMobile ||
                "true" != t.dataset.sliderDesktop
                ? e.contentRect.width < 990
                  ? "true" == t.dataset.sliderMobile
                    ? i
                    : o
                  : "true" == t.dataset.sliderDesktop
                    ? i
                    : o
                : i)(e.target);
            }).observe(s);
      }
    };
  t(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      e.target.classList.contains("featured-products-section") && t(e.target);
    });
})();
